import React from "react";
import { RichTextSummary } from "../richtext/RichTextSummary";
import { ProdPricing } from "./ProdPricing";
import { useNaviProduct } from "../../hooks/useNaviProduct";
import { useTranslation } from "react-i18next";

export const ProdCardOfTamiceChoiceBox: React.FC<ProductDTO> = (p) => {
  const navigate = useNaviProduct();
  const { t } = useTranslation();
  return (
    <div
      className="flex h-[120px] w-full cursor-pointer items-center overflow-hidden rounded-[12px] border border-[#DCDCDC] sm:h-[11.25rem] sm:rounded-[1rem]"
      onClick={() =>
        navigate.naviProduct({
          slug: p.slug,
          productType: p.productType,
        })
      }
    >
      <div className="wei-1 size-[120px] sm:size-[11.25rem]">
        <img
          src={p.thumbnail}
          alt={p.name}
          className="size-[120px] object-cover sm:size-[11.25rem]"
        />
      </div>
      <div className="flex h-full w-full flex-col items-start border-solid border-[#DCDCDC] bg-[#FFFFFF] p-3 sm:h-[11.25rem] sm:px-[1.25rem] sm:py-[1.3125rem]">
        <h5 className="mb-0 flex h-[1.5rem] items-center text-sm font-semibold leading-[22px] text-[#232323] sm:mb-1 sm:text-base sm:leading-[24px]">
          {t(p.name)}
        </h5>
        <p className="text-3-line flex items-center text-xs leading-[18px] text-[#5E6D77] sm:text-sm sm:leading-[22px]">
          <RichTextSummary richtext={p.information} />
        </p>
        <div className="mt-auto w-full">
          <ProdPricing {...p} />
        </div>
      </div>
    </div>
  );
};
